import CoreAuth from "Core/auth";
import {deleteStorageKey, STORAGE_TYPE} from 'Core/storage';

/**
 * App auth class
 * @note This class must extend CoreAuth class, but it does not have to implement any changes if no custom functionality
 * is needed.
 */
class Auth extends CoreAuth {
	/**
	 * Logout the user
	 * @description This method will just remove tokens from storage.
	 * @return {Promise<void>}
	 * @override Deleted project ID session storage value.
	 */
	static logout = () => {
		return super.logout()
			// Delete project ID session storage value
			.then(() => { deleteStorageKey('projectId', STORAGE_TYPE.SESSION) });
	}
}

export default Auth;